import { Box, Chip, Stack, Typography, useTheme } from '@mui/material'
import { FC } from 'react'
import vectorImage from '../../../../assets/images/main/vector-desktop.png'
import vectorImageMobile from '../../../../assets/images/main/vector-mobile.png'
import { featuresList } from '../../../../constants/featuresList'

export const AgentOrAssistantFeaturesList: FC = () => {
    const { breakpoints } = useTheme()

    return (
        <Box
            sx={{
                width: '100%',
                border: '1px solid #F4F4F6',
                borderRadius: '24px',
                p: 2,
                backgroundSize: 'contain',
                backgroundImage: `url(${vectorImage}), radial-gradient(circle,rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 58%, rgba(242, 249, 255, 1) 90%, rgba(242, 250, 255, 1) 100%)`,

                [breakpoints.down('md')]: {
                    backgroundImage: `url(${vectorImageMobile}), linear-gradient(45deg, rgb(233 243 255) 19%, rgba(255, 255, 255, 1) 37%, rgba(255, 255, 255, 1) 63%, rgb(233 241 255) 81%);`,
                },
            }}>
            <Stack
                direction="row"
                flexWrap="wrap"
                alignItems="center"
                justifyContent="center"
                gap={1}
                margin="0 auto"
                sx={{ maxWidth: '960px' }}>
                {featuresList.map(({ key, title, Icon }) => (
                    <Chip
                        key={key}
                        label={
                            <Stack direction="row" gap="6px" color="#5A5F72">
                                <Icon width={16} height={16} />
                                <Typography variant="caption2" color="#5A5F72">
                                    {title}
                                </Typography>
                            </Stack>
                        }
                        sx={{
                            height: '24px',
                            backgroundColor: '#F9FAFB',
                            '.MuiChip-label': {
                                padding: '4px 8px',
                            },
                        }}
                    />
                ))}
            </Stack>
        </Box>
    )
}
